var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',{staticClass:"font-weight-bold value-size"},[_vm._v(" "+_vm._s(_vm.value)),_c('span',[_vm._v(" "+_vm._s(_vm.info))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }